<template>
    <main-content v-if="$can('read', 'settlement')" with_go_back_bar>
        <div v-if="status=='success'">
            <manual-settlement v-if="form_data.type != 0" :form_data="display_data"/>
            <settlement-info v-else :form_data="display_data"/>
        </div>
    </main-content>
    <main-content v-else with_go_back_bar>
        <div v-if="status=='success'">
            <common-access-settlement-info :form_data="form_data"/>
        </div>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import { mapGetters } from 'vuex'
    import settlementInfo from './component/settlement-info'
    import commonAccessSettlementInfo from './component/common-access-settlement-info'
    import manualSettlement from './component/manual-settlement'

    export default {
        components: {
            mainContent,
            settlementInfo,
            commonAccessSettlementInfo,
            manualSettlement,
        },
        computed: {
            ...mapGetters('settlement', [
                'form_data', 'status'
            ]),
            is_direct() {
                return this.$route.query.direct == 1
            },
            // Direct (PSP) settlements have no description, tracking code or bank reference
            display_data() {
                if (!this.is_direct) {
                    return this.form_data
                }
                return {
                    ...this.form_data,
                    is_direct: true,
                    description: '',
                    tracking_code: '',
                    bank_reference: '',
                    details: (this.form_data.details || []).map(detail => ({...detail, bank_reference: ''})),
                }
            },
        },
        data() {
            return {
                hashid: this.$route.params.hashid
            }
        },
        beforeRouteEnter(to, from, next) {
        next(vm => {
            let is_admin = vm.$can('read', 'settlement');
            let action = is_admin ? 'settlement/adminFind' : 'settlement/find';
            if (vm.is_direct) {
                action = 'settlement/adminFindPspSettlement';
            }
            vm.$store.dispatch(action, vm.hashid);
        });
}

    }
</script>

<style>
</style>